<template>
  <div class="basic">
    <div class="basic-title">
      {{ information.name }}
    </div>
    <el-form
      :model="information"
      ref="validateForm"
      label-width="100px"
      class="demo-ruleForm"
      :rules="rules"
    >
      <el-form-item label="机构地址：" prop="address">
        <el-input
          type="text"
          v-model.number="information.address"
          placeholder="请输入机构地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="职能说明：" prop="function">
        <el-input
          type="textarea"
          v-model="information.function"
          maxlength="500"
          placeholder="请输入职能说明"
          show-word-limit
          :rows="17"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('validateForm')"
          >确认</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updateDepart } from '@/common/api/corporateInteraction/enterpriseGov'
export default {
  props: ['information'],
  data() {
    return {
      validateForm: {
        address: '',
        function: ''
      },
      rules: {
        address: [{ required: true, message: '请输入机构地址' }],
        function: [{ required: true, message: '请输入职能说明' }]
      }
    }
  },
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const params = {
            departId: this.information.id,
            address: this.information.address,
            function: this.information.function
          }
          updateDepart(params).then(res => {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
          })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.basic {
  &-title {
    font-size: 18px;
    font-weight: bold;
    margin: 20px;
    color: #000;
  }
}
/deep/.el-form {
  width: 40%;
  margin: 30px;
}
/deep/.el-input__count {
  bottom: 1px;
  right: 30px;
}
</style>
